<template>
  <div>
    <div :class="c.text900" class="cursor-pointer uppercase tracking-wide font-bold text-sm opacity-75" @click="toggleOpen">
      {{ letter.title }}
      <span v-show="!isOpen" class="opacity-75 mt-2 float-right"><svg xmlns="http://www.w3.org/2000/svg" width="11.314" height="7.071" viewBox="0 0 11.314 7.071"><path d="M9.293,12.95l.707.707L15.657,8,14.243,6.586,10,10.828,5.757,6.586,4.343,8Z" transform="translate(-4.343 -6.586)"/></svg></span>
      <span v-show="isOpen" class="opacity-75 mt-2 float-right"><svg xmlns="http://www.w3.org/2000/svg" width="11.314" height="7.071" viewBox="0 0 11.314 7.071"><path d="M10.707,7.05,10,6.343,4.343,12l1.414,1.414L10,9.172l4.243,4.242L15.657,12Z" transform="translate(-4.343 -6.343)"/></svg></span>
    </div>
    <transition name="fadse"><div v-show="isOpen" class="mt-1">{{ letter.info }}</div></transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
        isOpen: false
    }
  },
  props: {
    letter: {
        type: Object
    },
    c: {
        type: Object
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen ? this.isOpen = false : this.isOpen = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.fade-leave-active {
  transition: opacity .15s ease-in;
	animation: page-out 0.15s ease-in both;
  transform: translate3d(0,0,0);
}
.fade-enter-active{
  transition: opacity .15s ease-out;
  animation: page-in 0.15s 0.15s ease-out both;
  transform: translate3d(0,0,0);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@keyframes page-out {
    0% {
        transform: translateY(0);
        transform-origin: 50% 0%;
        opacity: 1;
    }
    100% {
        transform: translateY(20px);
        transform-origin: 50% 0%;
        opacity: 0;
    }
}


@keyframes page-in {
    0% {
        transform: translateY(-20px);
        transform-origin: 50% 0%;
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        transform-origin: 50% 0%;
        opacity: 1;
    }
}
</style>